import React, { useEffect, useState, useRef } from "react";
import "../../Styles/Components/Persons/PersonList.css";
import axios from "axios";
import Dialog_alert from '../PublicForms/Dialog_alert.js';
import {useNavigate } from "react-router-dom";
import LoaderComp from "../PublicForms/Loader.js";
import Config from "../PublicForms/Config.js";
import isTokenExpired from "../PublicForms/isTokenExpired.js";
import Navigation_Bar from "../PublicForms/Navigation_Bar.js";
import Header from "../PublicForms/Header.js";
import iconSubRecords from '../../Images/iconSubRecords.png';
import iconRemove from '../../Images/iconRemove.png';

const PersonList = ()=>
{

    const[loading, setLoading] = useState(false);
    const[personLst, setPersonLst] = useState([]);
    const[runUseEffect, setRunUseEffect] = useState(true);
    const[runUseEffectActive, setRunUseEffectActive] = useState(false);
    const[runUseDelete, setRunUseDelete] = useState(false);
    const[active, setActive] = useState(false);
    const[width, setWidth] = useState(0);
    const[personName, setPersonName] = useState("");
    const[personID, setPersonID] = useState();
    const[pages, setPages] = useState();
    const[runPagination, setRunPagination] = useState(false);
    const[page, setPage] = useState(1);
    const[pagesList, setPagesList] = useState([]);
    const[message, setMessage] = useState([]);
    const[messTitle, setMessTitle] = useState("");
    const[showDialog, setShowDialog] = useState(false);
    const[openNav, setOpenNav] = useState(false);
    const Navigate = useNavigate();
    const prevPageRef = useRef();
    const pageSize = 10;
    prevPageRef.current = 1;
    
    useEffect(() => {
        if (localStorage.getItem('token')) {
          const token = localStorage.getItem('token');
          if (isTokenExpired(token)) {
            localStorage.removeItem('token');
            Navigate("/login");
        } else {
            // setUser(JSON.parse(localStorage.getItem('user')));
          }
        } else {
            Navigate("/login");
        }
      }, []);
    
      useEffect(() => {
        function handleResize() {
          setWidth(window.innerWidth)
        }
        
        window.addEventListener("resize", handleResize)
        
        handleResize()
        
        
      }, []);

    useEffect(()=>
    {
        const deleteData = async ()=>
            {
              //0-fname, 1-lname, 2-bdate, 3-mobile, 4-home, 5-email, 6-city, 7-postal, 8-address, 9-descript
              axios.delete(
                `${Config.apiBaseUrl}/api/Person/${personID}`,{headers: {
               
                  "Authorization":`Bearer ${localStorage.getItem('token')}`,
                }
              }).then(response => 
              {
                  console.log(response)
                  if(response.status == 204)
                  {
                      setMessTitle("توجه");
                      setMessage((prevMessages) => {
                          return [
                            ...prevMessages, // shallow copy into new array reference
                            "اطلاعات فرد مورد نظر شما با موفقیت حذف شد",      // append new element
                          ];
                        });
                      setShowDialog(true);
          
                  }else
                  {
                      setMessTitle("خطا");
                      setMessage((prevMessages) => {
                          return [
                            ...prevMessages, // shallow copy into new array reference
                            "لطفا مجددا تلاش کنید",      // append new element
                          ];
                      });
                      setShowDialog(true);
                  }
          
              }).catch((err) =>{
                  
                  if(err.response !== null && err.response !== undefined)
                  {
                    setMessage([]);
                    if(err.response.status == 401)
                    {
                        Navigate("/login");
        
        
                    }else if((err.response.status) === 400)
                    {
                            setMessTitle("خطا");
                            setMessage((prevMessages) => {
                                return [
                                  ...prevMessages, // shallow copy into new array reference
                                  ("اطلاعات این کاربر قبلا حذف شده است."),      // append new element
                                ];
                            });
                            setShowDialog(true);
            
                    }else
                    {
                            setMessTitle("خطا");
                            setMessage((prevMessages) => {
                                return [
                                  ...prevMessages, // shallow copy into new array reference
                                  "لطفا مجددا تلاش کنید",      // append new element
                                ];
                            });
                            setShowDialog(true);
            
                    }
            
                  }else if(err.message == "Network Error")
                  {
                      setMessTitle("خطا");
                      setMessage((prevMessages) => {
                          return [
                            ...prevMessages, // shallow copy into new array reference
                            "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                          ];
                      });
                      setShowDialog(true);
                  }else
                  {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                                ...prevMessages, // shallow copy into new array reference
                                ("لطفا مجددا تلاش کنید"),      // append new element
                            ];
                        });                
                        
                        setShowDialog(true);
                  }
              })

              setRunUseDelete(false);
          }

        if(runUseDelete)
        {
            deleteData();
        }

    },[runUseDelete]);

      
    const personSearch = (search)=>
    {
        setPersonName(search);
        setPagesList([]);
        setRunUseEffect(true);   
        
    }

    const closeOpenDialog = (open) =>
    {
        setPersonLst([]);
        setShowDialog(false);
        setPagesList([]);         
        setRunPagination(false);
        setRunUseEffect(true);  
    }


    function goToShowDescript(personID)
    {
       Navigate(`/subscripts/lstSubscripts/اشتراک/subScriptLst/${personID}/true/false`);

    }


    const changePage = (pageNum, pagesNum) => {
        setRunUseEffect(true);
        setRunPagination(true);
        setPersonLst([]);
        setPage(pageNum);
        setPagesList([]);
    
       
      };

    const handleNave = ()=>
    {
        setOpenNav(!openNav);

    }

    const handleNaveForm = ()=>
    {
        if(!openNav)
        {
            setOpenNav(!openNav)
        }
    }

    useEffect(()=>
        {
            //pagesActive
            const pagesActive = async () => {
                setLoading(true);
                axios.get(`${Config.apiBaseUrl}/api/SubscriptDetails/1`,{headers: {
         
                    "Authorization":`Bearer ${localStorage.getItem('token')}`,
                  }
                }).then(response => 
                    {
                        if(response.status == 200)
                        {
                            var resp = Math.ceil(response.data.length/pageSize);
                            setPages(response.data.length/pageSize);
                            if(!runPagination)
                            {
                                if (resp <= 4 && resp >0) {
                                    for (let i = 1; i <= resp; i++) {
                                        pagesList.push(i);
                                    }
                                    }else if(resp>4) 
                                    {
                                    for (let i = 1; i <= 4; i++) {
                                        pagesList.push(i);
                                    }
                                    }
                            }
                              fetchActiveList();
                               
                        }else
                        {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                                ...prevMessages, // shallow copy into new array reference
                                "برقراری ارتباط با سرور مقدور نمی باشد، لطفا مجددا تلاش کنید",      // append new element
                            ];
                        });                
                        
                        setShowDialog(true);
                        }
            
                    }).catch((err) =>{
            
                        if(err.response !== null && err.response !== undefined)
                            {
                                setMessage([]);
                                if(err.response.status === 401)
                                {
                                    Navigate("/login");
                                }else if((err.response.status) === 500)
                                {
                                    setMessTitle("خطا");
                                    setMessage((prevMessages) => {
                                        return [
                                            ...prevMessages, // shallow copy into new array reference
                                            (err.response.detail),      // append new element
                                        ];
                                    });
                                    setShowDialog(true);
                    
                                }else
                                {
                                    setMessTitle("خطا");
                                    setMessage((prevMessages) => {
                                        return [
                                            ...prevMessages, // shallow copy into new array reference
                                            "لطفا مجددا تلاش کنید",      // append new element
                                        ];
                                    });
                                    setShowDialog(true);
                        
                                }
                    
                        }else if(err.message == "Network Error")
                        {
                            setMessTitle("خطا");
                            setMessage((prevMessages) => {
                                return [
                                    ...prevMessages, // shallow copy into new array reference
                                    "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                                ];
                            });
                            setShowDialog(true);
                        }else
                        {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                                ...prevMessages, // shallow copy into new array reference
                                ("لطفا مجددا تلاش کنید"),      // append new element
                            ];
                        });                
                        
                        setShowDialog(true);
                        }
                   })
                
            }
            const fetchActiveList = async () => {
                axios.get(`${Config.apiBaseUrl}/api/SubscriptDetails/1`,{headers: {
         
                    "Authorization":`Bearer ${localStorage.getItem('token')}`,
                  }
                }).then(response => 
                {
                    if(response.status == 200)
                    {
                        setPersonLst(response.data);
                        setRunUseEffectActive(false);
                        setLoading(false);
                           
                    }else
                    {
                    setMessTitle("خطا");
                    setMessage((prevMessages) => {
                        return [
                            ...prevMessages, // shallow copy into new array reference
                            ("لطفا مجددا تلاش کنید"),      // append new element
                        ];
                    });                
                    
                    setShowDialog(true);
                    }
        
                }).catch((err) =>{

                    setMessage([]);
                    if(err.response.status === 401)
                    {
                        Navigate("/login");
                    }else if((err.response.status) === 500)
                    {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                                ...prevMessages, // shallow copy into new array reference
                                (err.response.detail),      // append new element
                            ];
                        });
                        setShowDialog(true);
        
                    }else
                    {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                                ...prevMessages, // shallow copy into new array reference
                                "لطفا مجددا تلاش کنید",      // append new element
                            ];
                        });
                        setShowDialog(true);
            
                    }
                     
                    
               })
            }

            //pages
            const getPages = async () => {
                setLoading(true);
                setPersonLst([]);
                axios.get(`${Config.apiBaseUrl}/api/Person?PersonName=${personName}&which=false`,{headers: {
         
                    "Authorization":`Bearer ${localStorage.getItem('token')}`,
                  }
                }).then(response => 
                {

                    if(response.status == 200)
                    {
                        var resp = Math.ceil(response.data.length/pageSize);
                        setPages(resp);
                        if(!runPagination)
                        {
                            if (resp <= 4 && resp >0) {
                                for (let i = 1; i <= resp; i++) {
                                  pagesList.push(i);
                                }
                              }else if(resp>4) 
                              {
                                for (let i = 1; i <= 4; i++) {
                                  pagesList.push(i);
                                }
                              }
                        }
                    
                          fetchPersonList();
                           
                    }else
                    {
                    setMessTitle("خطا");
                    setMessage((prevMessages) => {
                        return [
                            ...prevMessages, // shallow copy into new array reference
                            ("برقراری ارتباط با سرور مقدور نمی باشد، لطفا مجددا تلاش کنید"),      // append new element
                        ];
                    });                
                    
                    setShowDialog(true);
                    }
        
                }).catch((err) =>{
        
                    
                        if(err.response !== null && err.response !== undefined)
                        {
                            setMessage([]);
                            if(err.response.status === 401)
                            {
                                Navigate("/login");
                            }else if((err.response.status) === 500)
                            {
                                setMessTitle("خطا");
                                setMessage((prevMessages) => {
                                    return [
                                        ...prevMessages, // shallow copy into new array reference
                                        (err.response.detail),      // append new element
                                    ];
                                });
                                setShowDialog(true);
                
                            }else
                            {
                                setMessTitle("خطا");
                                setMessage((prevMessages) => {
                                    return [
                                        ...prevMessages, // shallow copy into new array reference
                                        "لطفا مجددا تلاش کنید",      // append new element
                                    ];
                                });
                                setShowDialog(true);
                    
                            }
                
                        }else if(err.message == "Network Error")
                        {
                            setMessTitle("خطا");
                            setMessage((prevMessages) => {
                                return [
                                    ...prevMessages, // shallow copy into new array reference
                                    "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                                ];
                            });
                            setShowDialog(true);
                        }else
                        {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                                ...prevMessages, // shallow copy into new array reference
                                ("لطفا مجددا تلاش کنید"),      // append new element
                            ];
                        });                
                        
                        setShowDialog(true);
                        } 
               })
            }
    
            const fetchPersonList = async () => {
                setPersonLst([]);
                axios.get(`${Config.apiBaseUrl}/api/Person?PersonName=${personName}&PageSize=${pageSize}&PageNumber=${page-1}&which=false`,{headers: {
         
                    "Authorization":`Bearer ${localStorage.getItem('token')}`,
                  }
                }).then(response => 
                {
                    if(response.status == 200)
                    {
                        setPersonLst(response.data);
                        setRunUseEffect(false);
                        setLoading(false);
                           
                    }else
                    {
                    setMessTitle("خطا");
                    setMessage((prevMessages) => {
                        return [
                            ...prevMessages, // shallow copy into new array reference
                            ("لطفا مجددا تلاش کنید"),      // append new element
                        ];
                    });                
                    
                    setShowDialog(true);
                    }
        
                }).catch((err) =>{
        

                    if(err.response !== null && err.response !== undefined)
                        {
                            setMessage([]);
                            if((err.response.status) === 500)
                            {
                                setMessTitle("خطا");
                                setMessage((prevMessages) => {
                                    return [
                                        ...prevMessages, // shallow copy into new array reference
                                        (err.response.detail),      // append new element
                                    ];
                                });
                                setShowDialog(true);
                
                            }else
                            {
                                setMessTitle("خطا");
                                setMessage((prevMessages) => {
                                    return [
                                        ...prevMessages, // shallow copy into new array reference
                                        "لطفا مجددا تلاش کنید",      // append new element
                                    ];
                                });
                                setShowDialog(true);
                    
                            }
                
                    }else if(err.message == "Network Error")
                    {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                                ...prevMessages, // shallow copy into new array reference
                                "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                            ];
                        });
                        setShowDialog(true);
                    }else
                    {
                    setMessTitle("خطا");
                    setMessage((prevMessages) => {
                        return [
                            ...prevMessages, // shallow copy into new array reference
                            ("لطفا مجددا تلاش کنید"),      // append new element
                        ];
                    });                
                    
                    setShowDialog(true);
                    }
                  
                    
               })
            }
    
            if(runUseEffect === true)
            {
                getPages();

                if(runPagination)
                {

                    if (pages <= 4 && pages >0) {
                        for (let i = 1; i <= pages; i++) {
                            pagesList.push(i);
                        }
                    } else 
                    {
                        if (page == 1 || page == 2) {
                            for (let i = 1; i <= 4; i++) {
                            pagesList.push(i);
                            }
                        } else if (page > 2 && page <= pages - 2) {
                            for (let i = page - 2; i <= page + 2; i++) {
                            pagesList.push(i);
                            }
                        } else if (page > pages - 2 && page != pages) {
                            for (let i = page - 2; i <= pages; i++) {
                            pagesList.push(i);
                            }
                        } else if (page == pages-1) {
                            for (let i = page - 3; i <= pages; i++) {
                            pagesList.push(i);
                            }
                        }else if(page == pages)
                        {
                            for(let i = page - 4; i<= pages; i++)
                            {
                                pagesList.push(i);
                            }
                        }
                        
                   }
                }
                     
    
            }
    
            if(runUseEffectActive === true)
            {
                pagesActive();
                if(runPagination)
                {
                    setPagesList([]);
                    if (pages <= 4 && pages >0) {
                        for (let i = 1; i <= pages; i++) {
                            pagesList.push(i);
                        }
                    } else 
                    {
                        if (page == 1 || page == 2) {
                            for (let i = 1; i <= 4; i++) {
                            pagesList.push(i);
                            }
                        } else if (page > 2 && page <= pages - 2) {
                            for (let i = page - 2; i <= page + 2; i++) {
                            pagesList.push(i);
                            }
                        } else if (page > pages - 2 && page != pages) {
                            for (let i = page - 2; i <= pages; i++) {
                            pagesList.push(i);
                            }
                        } else if (page == pages-1) {
                            for (let i = page - 3; i <= pages; i++) {
                            pagesList.push(i);
                            }
                        }else if(page == pages)
                            {
                                for(let i = page - 4; i<= pages; i++)
                                {
                                    pagesList.push(i);
                                }
                        }
                        
                   }
                }
    
            }
    
        },[runUseEffectActive, runUseEffect])
    
    if(width>999)
    {

            if(loading)
            {
                return(<div className="personLst">
                        <p className="personLst-loader-txt"> لطفا چند لحظه صبر کنید...</p>   
                        <div className="personLst-loader">
                        <LoaderComp />
                        </div>
                    
                    </div>)
            }else
            {
                return(
                
                    <div className="personLst-all">
                        
                        <Header />
                        
                        <div className="navClass">
                        

                            <Navigation_Bar />
                            
                        </div>
                            
                        <div className="personLst">

                            <div className="personLst-top-page ">
                            <div className="searchContainer">
                                <input type="text"  placeholder="جستجو..." value={personName} autoFocus  onChange={(e)=>personSearch(e.target.value)}/>
                            </div>
                            
                            <label className="switch" >
                                <input type="checkbox" onChange={(e)=> 
                                    {
                                        setPagesList([]);
                                        setRunUseEffectActive(e.target.checked);
                                        setActive(e.target.checked);
                                        setRunUseEffect(!(e.target.checked));
                                        setRunPagination(false);
                                        setPage(1)


                                    }} checked = {active} />
                                <span className="slider round"></span>
                                <span className="tooltiptext">مشترکین فعال</span>

                            </label>
                            
                            </div>

                            <div className="table-responsive-sm personLst-tbl ">
                                <div className="table-responsive">
                                    <table className="table table-condensed">
                                        <thead>
                        
                                        <tr>
                                            <td>ردیف</td>
                                            <td>نام</td>
                                            <td>نام خانوادگی</td>
                                            <td>شهر</td>
                                            <td>شماره همراه</td>
                                            <td>شماره منزل</td>
                                            {/* <td>وضعیت اشتراک</td> */}
                                        </tr>
                        
                                        </thead>
                                        <tbody>
                                        {
                                        
                                            personLst.map((plst, i)=>
                                            {
                                                if(plst.detailsID == undefined)
                                                {
                                                  
                                                    return(
                                                            
                                                        <tr key={plst.personID} >
                                                            <td onClick={()=>{

                                                            Navigate(`/persons/previewPersons/افراد/new/${plst.personID}`);

                                                            }}>{i+(pageSize*(page-1))+1}</td>
                                                            <td onClick={()=>{

                                                                Navigate(`/persons/previewPersons/افراد/new/${plst.personID}`);

                                                                }}>{plst.person === undefined ? plst.firstName : plst.person.firstName}</td>
                                                            <td onClick={()=>{

                                                                Navigate(`/persons/previewPersons/افراد/new/${plst.personID}`);

                                                                }}>{plst.lastName}</td>
                                                            <td onClick={()=>{

                                                                Navigate(`/persons/previewPersons/افراد/new/${plst.personID}`);

                                                                }}>{plst.city === undefined ? plst.person.city.cityName : plst.city.cityName }</td>
                                                            <td onClick={()=>{

                                                                Navigate(`/persons/previewPersons/افراد/new/${plst.personID}`);

                                                                }}>{plst.phoneNumber}</td>
                                                            <td onClick={()=>{

                                                                Navigate(`/persons/previewPersons/افراد/new/${plst.personID}`);

                                                                }}>{plst.homeNumber}</td>
                                                            {/* <td onClick={()=>{

                                                                Navigate(`/persons/previewPersons/افراد/new/${plst.personID}`);

                                                                }}>{plst.subscriptDetails.length !== 0 ? plst.subscriptDetails.remainMonth>0 ? "فعال": "غیر فعال": "غیر فعال"}</td> */}
                                                            <td className="tbl-details" onClick={()=>goToShowDescript(plst.personID)}><img className="subRecImg" src={iconSubRecords}/></td>                                                                                                                          
                                                            <td className="tbl-details" onClick={()=>
                                                            {
                                                                setMessage([]);
                                                                setPersonID(plst.personID);
                                                                setRunUseDelete(true);

                                                            }}><img className="subRecImg" src={iconRemove}/> </td>                                                                                                                          
                                                        </tr>
                                                    ) 
                                                }else
                                                {
                                                    
                                                    return(
                                                            
                                                        <tr key={plst.person.personID} >
                                                            <td onClick={()=>{

                                                            Navigate(`/persons/previewPersons/افراد/new/${plst.person.personID}`);

                                                            }}>{i+(pageSize*(page-1))+1}</td>
                                                            <td onClick={()=>{

                                                                Navigate(`/persons/previewPersons/افراد/new/${plst.person.personID}`);

                                                                }}>{plst.person.firstName}</td>
                                                            <td onClick={()=>{

                                                                Navigate(`/persons/previewPersons/افراد/new/${plst.person.personID}`);

                                                                }}>{plst.person.lastName}</td>
                                                            <td onClick={()=>{

                                                                Navigate(`/persons/previewPersons/افراد/new/${plst.person.personID}`);

                                                                }}>{plst.person.city.cityName}</td>
                                                            <td onClick={()=>{

                                                                Navigate(`/persons/previewPersons/افراد/new/${plst.person.personID}`);

                                                                }}>{plst.person.phoneNumber}</td>
                                                            <td onClick={()=>{

                                                                Navigate(`/persons/previewPersons/افراد/new/${plst.person.personID}`);

                                                                }}>{plst.person.homeNumber}</td>
                                                            {/* <td onClick={()=>{

                                                                    Navigate(`/persons/previewPersons/افراد/new/${plst.personID}`);

                                                                    }}>{ "فعال"}</td> */}
                                                            <td className="tbl-details" onClick={()=>goToShowDescript(plst.person.personID)}><img className="subRecImg" src={iconSubRecords}/></td>                                                                                                                          
                                                            <td className="tbl-details" onClick={()=>
                                                            {
                                                                setMessage([]);
                                                                setPersonID(plst.person.personID);
                                                                setRunUseDelete(true);

                                                            }}><img className="subRecImg" src={iconRemove}/> </td>                                                                                                                          
                                                        </tr>
                                                    ) 
                                                }              
                                                

                                            })
                                        }
                                        </tbody>
                                        
                                    </table>

                                        <div
                                            style={{
                                            
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                marginTop: "5%",
                                            }}
                                            >
                                            <nav aria-label="Page navigation" style={{
                                            
                                            }}>
                                                <ul className="pagination" >
                                                <li key= "next" className="page-item">
                                                    <a
                                                    key = {999999999}
                                                    id={page < pages ? page + 1 : page}
                                                    className="page-item"
                                                    href="#"
                                                    aria-label="Next"
                                                    onClick={() =>
                                                        page < pages ? changePage(page + 1, pages) : null
                                                    }
                                                    
                                                    >
                                                    <span
                                                        aria-hidden="true"
                                                        style={page == 1 ? { color: "grey" } : null}
                                                    >
                                                        &laquo;

                                                    </span>
                                                    <span className="sr-only">Next</span>
                                                    </a>
                                                </li>
                                                {pagesList.slice(0).reverse().map((pageList,index) => {
                                                    return (
                                                    <li
                                                        key={index}
                                                        className="page-item"
                                                        onClick={() => changePage(pageList, pages)}
                                                    >
                                                        <a
                                                        id={pageList}
                                                        className={
                                                            pageList == page ? "page-link active" : "page-link"
                                                        }
                                                        href="#"
                                                        >
                                                        {pageList}
                                                        </a>
                                                    </li>
                                                    );
                                                })}
                                                <li key= {0} className="page-item">
                                                    <a
                                                        id={page > 1 ? page - 1 : page}
                                                        className="page-item"
                                                        href="#"
                                                        aria-label="Previous"
                                                        onClick={() =>
                                                            page > 1 ? changePage(page - 1, pages) : null
                                                        }
                                                    >
                                                    <span
                                                        aria-hidden="true"
                                                        style={pages == page ? { color: "grey" } : null}
                                                    >
                                                        &raquo;

                                                    </span>
                                                    <span className="sr-only">prev</span>
                                                    </a>
                                                </li>
                                                </ul>
                                            </nav>
                                        </div>
                                    </div>
                                {showDialog ? <Dialog_alert show = {showDialog} closeOpenDialog = {closeOpenDialog} messTitle ={messTitle} message = {message}/> : null}
                                                        
                            </div>    
                        </div>

                    </div>                       
                    
                )
            }

    }else
    {
        if(loading)
            {
                return(<div className="personLst">
                        <p className="personLst-loader-txt"> لطفا چند لحظه صبر کنید...</p>   
                        <div className="personLst-loader">
                        <LoaderComp />
                        </div>
                    
                    </div>)
            }else
            {
                return(

                    <div className="personLst-all-responsive">
                       
                          
                            <div className= {openNav? "navClass" : "navClass navClassOpen"}>
                                

                                <Navigation_Bar />
                                
                            </div>
                            

                        <div className="personLst-all">
                                
                              <Header handleNave={handleNave} />

                              
                                    
                                <div className="personLst" onClick={()=>handleNaveForm()}>

                                    <div className="personLst-top-page ">
                                    <div className="searchContainer">
                                        <input type="text"  placeholder="جستجو..." value={personName} autoFocus onChange={(e)=>personSearch(e.target.value)}/>
                                    </div>
                                    
                                    <label className="switch" >
                                        <input type="checkbox" onChange={(e)=> 
                                            {
                                                setPagesList([]);
                                                setRunUseEffectActive(e.target.checked);
                                                setActive(e.target.checked);
                                                setRunUseEffect(!(e.target.checked));
                                                setRunPagination(false);
                                                setPage(1)


                                            }} checked = {active} />
                                        <span className="slider round"></span>
                                        <span className="tooltiptext">مشترکین فعال</span>

                                    </label>
                                    
                                    </div>

                                    <div className="table-responsive-sm personLst-tbl ">
                                        <div className="table-responsive">
                                            <table className="table table-condensed">
                                                <thead>
                                
                                                <tr>
                                                    <td>ردیف</td>
                                                    <td>نام</td>
                                                    <td>نام خانوادگی</td>
                                                    <td>شهر</td>
                                                    <td>شماره همراه</td>
                                                    <td>شماره منزل</td>
                                                    <td>وضعیت اشتراک</td>
                                                </tr>
                                
                                                </thead>
                                                <tbody>
                                                {
                                                    personLst.map((plst, i)=>
                                                    {
                                                        
                                                        return(
                                                            <tr key={plst.personID} >
                                                                <td onClick={()=>{

                                                                Navigate(`/persons/previewPersons/افراد/new/${plst.personID}`);

                                                                }}>{i+(pageSize*(page-1))+1}</td>
                                                                <td onClick={()=>{

                                                                    Navigate(`/persons/previewPersons/افراد/new/${plst.personID}`);

                                                                    }}>{plst.person === undefined ? plst.firstName : plst.person.firstName}</td>
                                                                <td onClick={()=>{

                                                                    Navigate(`/persons/previewPersons/افراد/new/${plst.personID}`);

                                                                    }}>{plst.lastName}</td>
                                                                <td onClick={()=>{

                                                                    Navigate(`/persons/previewPersons/افراد/new/${plst.personID}`);

                                                                    }}>{plst.city === undefined ? plst.person.city.cityName : plst.city.cityName }</td>
                                                                <td onClick={()=>{

                                                                    Navigate(`/persons/previewPersons/افراد/new/${plst.personID}`);

                                                                    }}>{plst.phoneNumber}</td>
                                                                <td onClick={()=>{

                                                                    Navigate(`/persons/previewPersons/افراد/new/${plst.personID}`);

                                                                    }}>{plst.homeNumber}</td>
                                                                <td onClick={()=>{

                                                                        Navigate(`/persons/previewPersons/افراد/new/${plst.personID}`);

                                                                        }}>{plst.subscriptDetails !== undefined ? plst.subscriptDetails.remainMonth>0 ? "فعال": "غیر فعال": "غیر فعال"}</td>

                                                                <td className="tbl-details" onClick={()=>goToShowDescript(plst.personID)}><img className="subRecImg" src={iconSubRecords}/></td>                                                                                                                          
                                                                <td className="tbl-details" onClick={()=>
                                                                {
                                                                    setMessage([]);
                                                                    setPersonID(plst.personID);
                                                                    setRunUseDelete(true);

                                                                }}><img className="subRecImg" src={iconRemove}/> </td>                                                                                                                          
                                                            </tr>
                                                        )                
                                                        
                                                    })
                                                }
                                                </tbody>
                                                
                                            </table>

                                                <div
                                                    style={{
                                                    
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        marginTop: "5%",
                                                        direction:"rtl"
                                                    }}
                                                    >
                                                    <nav aria-label="Page navigation" style={{
                                                        direction:"rtl"
                                                    
                                                    }}>
                                                        <ul className="pagination" >
                                                        <li key= "next" className="page-item">
                                                            <a
                                                            key = {999999999}
                                                            id={page < pages ? page + 1 : page}
                                                            className="page-item"
                                                            href="#"
                                                            aria-label="Next"
                                                            onClick={() =>
                                                                page < pages ? changePage(page + 1, pages) : null
                                                            }
                                                            
                                                            >
                                                            <span
                                                                aria-hidden="true"
                                                                style={page == 1 ? { color: "grey" } : null}
                                                            >
                                                                &laquo;

                                                            </span>
                                                            <span className="sr-only">Next</span>
                                                            </a>
                                                        </li>
                                                        {pagesList.slice(0).reverse().map((pageList,index) => {
                                                            return (
                                                            <li
                                                                key={index}
                                                                className="page-item"
                                                                onClick={() => changePage(pageList, pages)}
                                                            >
                                                                <a
                                                                id={pageList}
                                                                className={
                                                                    pageList == page ? "page-link active" : "page-link"
                                                                }
                                                                href="#"
                                                                >
                                                                {pageList}
                                                                </a>
                                                            </li>
                                                            );
                                                        })}
                                                        <li key= {0} className="page-item">
                                                            <a
                                                                id={page > 1 ? page - 1 : page}
                                                                className="page-item"
                                                                href="#"
                                                                aria-label="Previous"
                                                                onClick={() =>
                                                                    page > 1 ? changePage(page - 1, pages) : null
                                                                }
                                                            >
                                                            <span
                                                                aria-hidden="true"
                                                                style={pages == page ? { color: "grey" } : null}
                                                            >
                                                                &raquo;

                                                            </span>
                                                            <span className="sr-only">prev</span>
                                                            </a>
                                                        </li>
                                                        </ul>
                                                    </nav>
                                                </div>
                                            </div>
                                        {showDialog ? <Dialog_alert show = {showDialog} closeOpenDialog = {closeOpenDialog} messTitle ={messTitle} message = {message}/> : null}
                                                                
                                    </div>    
                                </div>

                            </div> 
                    </div>                                                 
                    
                )
            }
    }
    
   
}

export default PersonList;

